import React, { useState, useEffect } from "react";
import * as sweetalert from "sweetalert";
import axios from "axios";
import { getAllfund } from "../../../services";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "./useForm";
import { Grid } from "@material-ui/core";
import { getAllPaymentMethod } from "../../../services/paymentMethod";
import ConfirmDialogAddNumber from "../global/ConfirmDialogAddNumber";
import ConfirmDialogListNumber from "../global/ConfirmDialogListNumber";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { Checkbox, FormControlLabel } from "@mui/material";
import ConfirmDialog from "../global/ConfirmDialogCon";

import packageJson from "../../../../package.json";
import { getAllServices } from "../../../services/Services";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function CreateTransactions() {
  const [fund, setfund] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [fundoption, setFundoption] = useState([]);
  const convert_mobile = localStorage.getItem("convert_mobile");
  const [isDebt, setIsDebt] = useState(0); // Default to unchecked

  const [mobile_number, setMobile_number] = useState(convert_mobile);
  const [priceamount, setPriceAmount] = useState();
  const [fundpost, setFundpost] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [Fundvalue, setFundvalue] = useState([]);
  const [fundbuyprice, setFundbuyprice] = useState("");
  const [fundsellprice, setFundsellprice] = useState("");
  const [Description, setDescription] = useState("");
  const [data1, setdata1] = useState("");
  const [data2, setdata2] = useState("");
  const [message, setmessage] = useState("");
  const [ServicesData, setServices] = useState([]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [confirmDialog1, setConfirmDialog1] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [confirmDialog2, setConfirmDialog2] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  // useEffect(() => {}, [stringDataloading]);
  useEffect(() => {}, [fundbuyprice, fundsellprice]);
  useEffect(() => {
    setIsLoading(true);
    getAllfund()
      .then((res) => {
        setfund(res.data);

        setIsLoading(true);
      })
      .catch((err) => {
        setfund([]);

        setIsLoading(false);
      });
    getAllPaymentMethod()
      .then((res) => {
        setPaymentMethod(res.data);

        setIsLoading(true);
      })
      .catch((err) => {
        setfund([]);

        setIsLoading(false);
      });
    getAllServices()
      .then((res) => {
        setServices(res);
        setIsLoading(false);
      })
      .catch((err) => {
        setServices([]);
        setIsLoading(false);
      });

    return () => {};
  }, []);
  const staff_type = localStorage.getItem("staff_type");
  const mobile_number_login = localStorage.getItem("mobile_number_login");
  const initialFValues = {
    mobile_number: "",
    amount: "",
    payment_method: "",
    bank: "",
    number_transfer: "",
    image: "",
    description: "",
    is_debt: "",
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("mobile_number" in fieldValues) {
      if (fieldValues.mobile_number == "") {
        temp.mobile_number = " رقم الموبايل مطلوب";
      } else if (!/[0-9]/.test(fieldValues.mobile_number)) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل أرقام";
      } else {
        temp.mobile_number = "";
      }
    }
    if (fundoption === "BankTransfer") {
      if ("bank" in fieldValues) {
        if (fieldValues.bank == "") {
          temp.bank = "هذا الحقل مطلوب";
        } else {
          temp.bank = "";
        }
      }
      if ("number_transfer" in fieldValues) {
        if (fieldValues.number_transfer == "") {
          temp.number_transfer = "هذا الحقل مطلوب";
        } else {
          temp.number_transfer = "";
        }
      }
      if ("image" in fieldValues) {
        if (fieldValues.image == "") {
          temp.image = "هذا الحقل مطلوب";
        } else {
          temp.image = "";
        }
      }
    } else {
      if ("bank" in fieldValues) {
        if (fieldValues.bank == "") {
          temp.bank = "";
        } else {
          temp.bank = "";
        }
      }
      if ("number_transfer" in fieldValues) {
        if (fieldValues.number_transfer == "") {
          temp.number_transfer = "";
        } else {
          temp.number_transfer = "";
        }
      }
      if ("image" in fieldValues) {
        if (fieldValues.image == "") {
          temp.image = "";
        } else {
          temp.image = "";
        }
      }
    }
    if ("amount" in fieldValues)
      temp.amount = fieldValues.amount ? "" : " الكمية مطلوبة";
    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const validate2 = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("mobile_number" in fieldValues) {
      if (
        fieldValues.mobile_number !== "" &&
        !/^[0-9]+$/.test(fieldValues.mobile_number)
      ) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (
        fieldValues.mobile_number !== "" &&
        fieldValues.mobile_number.length !== 10
      ) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل 10 أرقام";
      } else if (
        fieldValues.mobile_number !== "" &&
        fieldValues.mobile_number.length === 10
      ) {
        temp.mobile_number = "";
        axios
          .post(
            `${BaseUrl}/api/getFundCacheValues`,
            { mobile_number: fieldValues.mobile_number },
            {
              withCredentials: true,
            }
          )
          .then((res) => {
            if (res.status === 200) {
              setFundvalue(res.data.data);
            }
          })
          .catch((error) => {
            console.error("Error in API call:", error);
            // Handle errors as needed
          });
      } else {
        temp.mobile_number = "";
      }
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const { loginInput, setLogin, errors, setErrors, addForm } = useForm(
    initialFValues,
    true,
    validate,
    validate2
  );

  const handleSubmit = () => {
    // e.preventDefault();
    if (validate()) {
      setLoading(true);
      const data = {
        mobile_number: mobile_number,
        amount: fundpost,
        description: Description,
        fund_value_id: loginInput.fund_value_id,
        is_debt: isDebt,
      };
      axios
        .post(`${BaseUrl}/api/EPayment`, data, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status === true) {
            setLoading(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              window.location.reload();
            });
          } else if (res.data.status === false) {
            setLoading(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              window.location.reload();
            });
          }
        });
    }
  };

  const handleChange = (e, fieldName) => {
    const value = e.target.value;

    if (fieldName === "mobile_number") {
      setMobile_number(value);
      setLogin({ ...loginInput, mobile_number: e.target.value });
    }
    if (fieldName === "description") {
      setDescription(value);
      setLogin({ ...loginInput, description: e.target.value });
    }
  };

  const handleChange1 = (e) => {
    const selectedOption = Fundvalue.find(
      (opt) => opt.id === parseInt(e.target.value, 10)
    );
    setFundbuyprice(selectedOption ? selectedOption.fund_price : "");
    setFundsellprice(selectedOption ? selectedOption.sell_price : "");
    setFundpost(selectedOption ? selectedOption.fund_value : "");
    setLogin({
      ...loginInput,
      amount: selectedOption.fund_value,
      fund_value_id: selectedOption.id,
    });
  };
  useEffect(() => {
    validate2(loginInput);
  }, [loginInput]);
  useEffect(() => {
    validate2(loginInput);
  }, [loginInput]);
  useEffect(() => {
    if (loading === true && !validate()) {
      setTimeout(() => {
        // After the timeout, reset the loading state
        setLoading(false);
        // Your other logic here
      }, 2000); // Adjust the timeout duration as needed
    }
  }, [loading]);
  function handleCheck() {
    let msg;
    const data = {
      phone: mobile_number,
    };
    axios
      .post(`${BaseUrl}/api/checkNumberExistsAlready`, data, {
        withCredentials: true,
      })

      .then((res) => {
        if (res.data.status === true) {
          setdata1(res.data.data);
          setmessage(res.data.msg);
          msg = res.data.msg;
        }
        setConfirmDialog({
          isOpen: true,
          title: res.data.msg,
          subTitle: "إضافة رقم الموبايل إلى سجل الارقام",
          onConfirm: () => {},
        });
      });
  }
  function handleListNumber() {
    axios
      .get(`${BaseUrl}/api/getMyCustomer`, {
        withCredentials: true,
      })

      .then((res) => {
        if (res.data.status === true) {
          setdata2(res.data.data);
          setmessage(res.data.msg);
        }
      });
    setConfirmDialog1({
      isOpen: true,
      title: "سجل الارقام",
      onConfirm: () => {},
    });
  }
  useEffect(() => {
    if (convert_mobile != "") {
      const data = {
        mobile_number: convert_mobile,
      };

      setLogin({ ...loginInput, mobile_number: convert_mobile });
      axios
        .post(`${BaseUrl}/api/getFundValues`, data, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.status === 200) {
            setFundvalue(res.data.data);
          }
        })
        .catch((error) => {
          console.error("Error in API call:", error);
          // Handle errors as needed
        });
    }
    setMobile_number(convert_mobile);
  }, [convert_mobile]);
  useEffect(() => {
    const convert_mobile = localStorage.getItem("convert_mobile");
    if (convert_mobile) {
      setMobile_number(convert_mobile);
      setLogin({ ...loginInput, mobile_number: convert_mobile });
      // Clear the local storage after setting the state
      localStorage.removeItem("convert_mobile");
    } else {
      setMobile_number("");
      setLogin({ ...loginInput, mobile_number: "" });
    }
  }, []);
  return (
    <div className="main-div">
      <h3 className="titlepage">تحويل رصيد كاش موبايل</h3>
      {ServicesData[3]?.name == "CacheMobile" &&
      ServicesData[3]?.is_active == 1 ? (
        <Grid className="form-group new-design">
          <Grid container maxWidth="sm" spacing={4}>
            {/* <Grid item md={6} xs={12}>
            <Controls.Input
              label="رقم الموبايل"
              name="mobile_number"
              variant="outlined"
              fullWidth
              onChange={(e) => handleChange(e, "mobile_number")}
              value={mobile_number}
              className="form-control"
              error={errors.mobile_number}
              type="number"
            />
            
          </Grid> */}
            <Grid
              item
              md={6}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid item md={10} xs={12}>
                <Controls.Input
                  label="رقم الموبايل"
                  name="mobile_number"
                  variant="outlined"
                  fullWidth
                  onChange={(e) => handleChange(e, "mobile_number")}
                  value={mobile_number}
                  className="form-control"
                  error={errors.mobile_number}
                />
              </Grid>
              <Grid item md={2} xs={12}>
                <AddCircleIcon
                  style={{ cursor: "pointer" }}
                  className="svgadd"
                  onClick={() => {
                    handleCheck();
                  }}
                />
                <ConfirmDialogAddNumber
                  confirmDialog={confirmDialog}
                  setConfirmDialog={setConfirmDialog}
                  phone={mobile_number}
                  data1={data1}
                />
                <AssignmentTurnedInIcon
                  style={{ cursor: "pointer" }}
                  className="svgadd1"
                  onClick={() => {
                    handleListNumber();
                  }}
                />
                <ConfirmDialogListNumber
                  confirmDialog={confirmDialog1}
                  setConfirmDialog={setConfirmDialog1}
                  phone={mobile_number}
                  data2={data2}
                />
              </Grid>
            </Grid>
            {/* <Grid item md={6} xs={12}>

            <label>قيمة الرصيد</label>
            <div class="select">
              <select
                className="form-control"
                class="select-text"
                name="amount"
                onChange={(e) => handleChange1(e, Fundvalue.find(opt => opt.fund_value === e.target.value))}
                error={errors.amount}
              >
                <option selected disabled>
                  اختر قيمة الرصيد
                </option>
                {Fundvalue && Fundvalue.map((opts, i) => (
                  <option key={opts.id} value={opts.fund_value}>
                    {opts.fund_value}
                  </option>
                ))}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
            </div>
            {loginInput.amount == "" ? (
              <div style={{ color: "red", fontSize: "10px" }}>
                {errors.amount}
              </div>
            ) : (
              <></>
            )}
          </Grid> */}
            <Grid item md={6} xs={12}>
              <label>قيمة الرصيد</label>
              <div class="select">
                <select
                  className="form-control"
                  class="select-text"
                  name="amount"
                  onChange={(e) => handleChange1(e)}
                  error={errors.amount}
                >
                  <option selected disabled>
                    اختر قيمة الرصيد
                  </option>
                  {Fundvalue &&
                    Fundvalue.map((opts, i) => (
                      <option key={opts.id} value={opts.id}>
                        {opts.fund_value}
                      </option>
                    ))}
                </select>
                <span class="select-highlight"></span>
                <span class="select-bar"></span>
              </div>
              {loginInput.amount == "" ? (
                <div style={{ color: "red", fontSize: "10px" }}>
                  {errors.amount}
                </div>
              ) : (
                <></>
              )}
            </Grid>
            <Grid item md={6} xs={12}>
              <Controls.Input
                label="سعر الشراء"
                name=""
                variant="outlined"
                disabled
                fullWidth
                value={fundbuyprice || ""}
                className="form-control"
                type="number"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Controls.Input
                label="سعر المبيع"
                name=""
                variant="outlined"
                fullWidth
                disabled
                value={fundsellprice || ""}
                className="form-control"
                type="number"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Controls.Input
                label="وصف"
                name="description"
                variant="outlined"
                fullWidth
                value={Description}
                onChange={(e) => handleChange(e, "description")}
                className="form-control"
                type="text"
                error={errors.description}
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isDebt === 1}
                    onChange={(e) => setIsDebt(e.target.checked ? 1 : 0)}
                    name="isDebt"
                    className="svgcheck"
                  />
                }
                label="هل هو دين؟" // Replace with your label
              />
            </Grid>
          </Grid>

          <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
            {loading === true ? (
              <Controls.Button
                text=<div class="spinner center">
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                </div>
                variant="contained"
                className="btn-submit"
              ></Controls.Button>
            ) : (
              <>
                <Controls.Button
                  type="submit"
                  text="تحويل"
                  // disabled={stringDataloading === true ? true : false}
                  variant="contained"
                  onClick={() => {
                    if (validate()) {
                      setConfirmDialog2({
                        isOpen: true,
                        title: "هل تريد القيام بهذه العملية",
                        subTitle: "",
                        onConfirm: () => {
                          handleSubmit();
                        },
                      });
                    }
                  }}
                  className="btn-submit"
                ></Controls.Button>
                <ConfirmDialog
                  confirmDialog={confirmDialog2}
                  setConfirmDialog={setConfirmDialog2}
                />
              </>
            )}
          </Grid>
        </Grid>
      ) :  ServicesData[3]?.name == "CacheMobile" &&
        ServicesData[3]?.is_active == 0 && staff_type == "Admin" &&
                  mobile_number_login == "0950555563" ? (
        <Grid className="form-group new-design">
          <Grid container maxWidth="sm" spacing={4}>
            {/* <Grid item md={6} xs={12}>
            <Controls.Input
              label="رقم الموبايل"
              name="mobile_number"
              variant="outlined"
              fullWidth
              onChange={(e) => handleChange(e, "mobile_number")}
              value={mobile_number}
              className="form-control"
              error={errors.mobile_number}
              type="number"
            />
            
          </Grid> */}
            <Grid
              item
              md={6}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid item md={10} xs={12}>
                <Controls.Input
                  label="رقم الموبايل"
                  name="mobile_number"
                  variant="outlined"
                  fullWidth
                  onChange={(e) => handleChange(e, "mobile_number")}
                  value={mobile_number}
                  className="form-control"
                  error={errors.mobile_number}
                />
              </Grid>
              <Grid item md={2} xs={12}>
                <AddCircleIcon
                  style={{ cursor: "pointer" }}
                  className="svgadd"
                  onClick={() => {
                    handleCheck();
                  }}
                />
                <ConfirmDialogAddNumber
                  confirmDialog={confirmDialog}
                  setConfirmDialog={setConfirmDialog}
                  phone={mobile_number}
                  data1={data1}
                />
                <AssignmentTurnedInIcon
                  style={{ cursor: "pointer" }}
                  className="svgadd1"
                  onClick={() => {
                    handleListNumber();
                  }}
                />
                <ConfirmDialogListNumber
                  confirmDialog={confirmDialog1}
                  setConfirmDialog={setConfirmDialog1}
                  phone={mobile_number}
                  data2={data2}
                />
              </Grid>
            </Grid>
            {/* <Grid item md={6} xs={12}>

            <label>قيمة الرصيد</label>
            <div class="select">
              <select
                className="form-control"
                class="select-text"
                name="amount"
                onChange={(e) => handleChange1(e, Fundvalue.find(opt => opt.fund_value === e.target.value))}
                error={errors.amount}
              >
                <option selected disabled>
                  اختر قيمة الرصيد
                </option>
                {Fundvalue && Fundvalue.map((opts, i) => (
                  <option key={opts.id} value={opts.fund_value}>
                    {opts.fund_value}
                  </option>
                ))}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
            </div>
            {loginInput.amount == "" ? (
              <div style={{ color: "red", fontSize: "10px" }}>
                {errors.amount}
              </div>
            ) : (
              <></>
            )}
          </Grid> */}
            <Grid item md={6} xs={12}>
              <label>قيمة الرصيد</label>
              <div class="select">
                <select
                  className="form-control"
                  class="select-text"
                  name="amount"
                  onChange={(e) => handleChange1(e)}
                  error={errors.amount}
                >
                  <option selected disabled>
                    اختر قيمة الرصيد
                  </option>
                  {Fundvalue &&
                    Fundvalue.map((opts, i) => (
                      <option key={opts.id} value={opts.id}>
                        {opts.fund_value}
                      </option>
                    ))}
                </select>
                <span class="select-highlight"></span>
                <span class="select-bar"></span>
              </div>
              {loginInput.amount == "" ? (
                <div style={{ color: "red", fontSize: "10px" }}>
                  {errors.amount}
                </div>
              ) : (
                <></>
              )}
            </Grid>
            <Grid item md={6} xs={12}>
              <Controls.Input
                label="سعر الشراء"
                name=""
                variant="outlined"
                disabled
                fullWidth
                value={fundbuyprice || ""}
                className="form-control"
                type="number"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Controls.Input
                label="سعر المبيع"
                name=""
                variant="outlined"
                fullWidth
                disabled
                value={fundsellprice || ""}
                className="form-control"
                type="number"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Controls.Input
                label="وصف"
                name="description"
                variant="outlined"
                fullWidth
                value={Description}
                onChange={(e) => handleChange(e, "description")}
                className="form-control"
                type="text"
                error={errors.description}
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isDebt === 1}
                    onChange={(e) => setIsDebt(e.target.checked ? 1 : 0)}
                    name="isDebt"
                    className="svgcheck"
                  />
                }
                label="هل هو دين؟" // Replace with your label
              />
            </Grid>
          </Grid>

          <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
            {loading === true ? (
              <Controls.Button
                text=<div class="spinner center">
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                </div>
                variant="contained"
                className="btn-submit"
              ></Controls.Button>
            ) : (
              <>
                <Controls.Button
                  type="submit"
                  text="تحويل"
                  // disabled={stringDataloading === true ? true : false}
                  variant="contained"
                  onClick={() => {
                    if (validate()) {
                      setConfirmDialog2({
                        isOpen: true,
                        title: "هل تريد القيام بهذه العملية",
                        subTitle: "",
                        onConfirm: () => {
                          handleSubmit();
                        },
                      });
                    }
                  }}
                  className="btn-submit"
                ></Controls.Button>
                <ConfirmDialog
                  confirmDialog={confirmDialog2}
                  setConfirmDialog={setConfirmDialog2}
                />
              </>
            )}
          </Grid> 
          </Grid> 
        
      ) : 
       ServicesData[3]?.name == "CacheMobile" &&
        ServicesData[3]?.is_active == 0 ? (
        <div class="services-no-available">
          هذه الخدمة غير متاحة
          <img src="7703205.webp" />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
